let lastId = 0;

const newId = () => {
  lastId++;

  return lastId.toString();
};

export default newId;
